import {
  SALESTYPE_LOADING,
  GET_SALESTYPE,
  GET_SALESTYPE_SUCCESS,
  GET_SALESTYPE_FAIL,
  ADD_SALESTYPE_SUCCESS,
  ADD_SALESTYPE_FAIL,
  DELETE_SALESTYPE_SUCCESS,
  DELETE_SALESTYPE_FAIL,
  UPDATE_SALESTYPE_SUCCESS,
  UPDATE_SALESTYPE_FAIL,
  SALESTYPE_RESET
} from "./actionType";

const INIT_STATE = {
  salesTypes: [],
  error: {},
};

const SalesType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESTYPE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESTYPE:
          return {
            ...state,
            salesTypes: action.payload.data,
            isSalesTypeCreated: false,
            isSalesTypeSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESTYPE_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESTYPE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesTypeCreated: false,
            isSalesTypeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESTYPE: {
      return {
        ...state,
        isSalesTypeCreated: false,
        loading: true,
      };
    }

    case SALESTYPE_LOADING: {
      return {
        ...state,
        isSalesTypeCreated: false,
        loading: true,
      };
    }

    case ADD_SALESTYPE_SUCCESS:
      return {
        ...state,
        isSalesTypeCreated: true,
        loading: false,
        salesTypes: [action.payload.data, ...state.salesTypes],
      };

    case ADD_SALESTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesTypeCreated: true,
        salesTypes: state.salesTypes.filter(
          salesType => salesType.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesTypeCreated: true,
        salesTypes: state.salesTypes.map(salesType =>
          salesType.id.toString() === action.payload.data.id.toString() ? { ...salesType, ...action.payload.data } : salesType
        ),
      };

    case UPDATE_SALESTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESTYPE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesType;